const mutations={
	increment(state,payload){
		state.usermesg=payload
	}
}
export default mutations


// WEBPACK FOOTER //
// ./src/store/mutations.js